import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';
import { SharedDataService } from '../../service/shared-data.service';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
@Component({
  selector: '.photo-listing',
  templateUrl: './photo-listing.component.html',
  styleUrls: ['./photo-listing.component.scss']
})

export class PhotoListingComponent implements OnInit {
  listImageArray: any[] = [];
  showMyWorkSpace = false;
  showAllStory = true;
  showMy = false;
  showCrossTenant = false;
  showMobile = false;
  showPixabay = false;
  selectedItem = 'gridView';
  @Output() emitIdfn = new EventEmitter<any>();
  showPhotogallery = false;
  domainConfig: any;
  domainWiseImageList: boolean;
  isMobile91Enabled: boolean;
  enablePixabay: boolean;
  @Input()
  set photogalleryId(photogalleryId: boolean) {
    this.showPhotogallery = photogalleryId;
  }
  @Input() exclusionList: any[];

  constructor(
    private sharedService: SharedDataService,
    private gaService:GoogleAnalyticsService
  ) {
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
   }
  
  getDomainConfig(currentDomainConfig) {
    this.domainConfig = currentDomainConfig;
    if(this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['crossTenantDomainList']) {
      this.domainWiseImageList =  this.domainConfig['config']['image']['crossTenantDomainList'];
    }
    this.enablePixabay = this.domainConfig && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['enablePixabay']
    this.isMobile91Enabled =  this.sharedService.isdomainConfig('image', 'isMobile91Enabled');
  }
  ngOnInit() {
  }

  openTabs(tab) {
    let eventCategory='Lead Image';
    let eventAction= 'Pick from Library Wires'
    let eventLabel = window.location.href;
    let eventValue=null;
    this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
  }
  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
    this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
   }
  sendIdToParent(ev) {
    this.emitIdfn.emit(ev);
  }
  sendImageIdToParent(ev) {
    this.listImageArray = ev;
  }
  setClearList(ev){
    if(ev)
    {
      this.listImageArray = [];
      this.showAllStory = true;
      this.showCrossTenant = false;
      this.showMobile = false; 
      this.showMy = false;
      this.showMyWorkSpace = false;
      this.showPixabay=false;
    }
  }
}